"use strict";
(self["webpackChunktom_bihn"] = self["webpackChunktom_bihn"] || []).push([[2024],{

/***/ 2024:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ buyPanel)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function buyPanel({ wrapper }) {
  ;(function init() {
    
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('variant-selector:change', updateURL)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('variant-selector:change', updateReadyToShipBadge)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('variant-selector:change', updateShippingMessage)
    
  })()

  function updateURL(event, { variant, product }) {
    const newURL = new URL(location.href);

    newURL.searchParams.set('variant', variant.id)
    history.replaceState(null, '', newURL);
  }

  function updateReadyToShipBadge(event, { variant }) {
    const readyToShipBadge = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find('[data-available-badge]');
    
    if (variant.available) {
      readyToShipBadge.show();
    } else {
      readyToShipBadge.hide();
    }
  }

  function updateShippingMessage(event, { variant, product }) {
    // Get the shipping message element
    const $shippingMessage = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find('.js-shipping-message');
    
    // Get custom data from global variables (defined in product-scripts.liquid)
    const variantInventoryStatus = window.customVariantStatus ? window.customVariantStatus[variant.id] : null;
    const shippingMessageNote = window.customCartMsgs ? window.customCartMsgs[variant.id] : null;
    const baseProductionVariants = window.base_production_variants || [];
    const customProductionMsg = window.custom_production_msg || {};

    if (variant.available) {
      // Variant is in stock
      if (shippingMessageNote) {
        $shippingMessage
          .show()
          .html(shippingMessageNote)
          .addClass('in-production')
          .removeClass('in-stock out-of-stock');
      } else {
        $shippingMessage.hide();
      }
    } else {
      // Variant is out of stock
      if (
        variant.inventory_quantity <= 0 &&
        variant.inventory_quantity > -100 &&
        variantInventoryStatus !== 'In Production' &&
        variantInventoryStatus !== 'In Production_forced'
      ) {
        // Out of stock
        let stockMessage = '';
        
        if (baseProductionVariants.indexOf(variant.sku) >= 0) {
          stockMessage = "We'll be making this bag in our Seattle factory soon, and we'll update this notice when we have an estimate as to when it will be ready to ship.";
        } else {
          stockMessage = "Hi there! This size or color isn't currently in production.";
        }

        if (stockMessage) {
          $shippingMessage
            .show()
            .html(stockMessage)
            .addClass('out-of-stock')
            .removeClass('in-production in-stock');
        } else {
          $shippingMessage.hide();
        }
      } else {
        // In production
        let productionMessage = '';

        if (variant.sku.indexOf('PXXX') === 0 || variant.sku.indexOf('TB05XXX') === 0) {
          productionMessage = 'More of these are on the way and we expect them to be available for order soon!';
        } else {
          if (customProductionMsg.hasOwnProperty(variant.sku)) {
            productionMessage = customProductionMsg[variant.sku];
          } else {
            productionMessage = "We're making this bag in our Seattle factory and expect it to be available for order within the next 2 - 12 weeks.";
          }
        }

        if (productionMessage) {
          $shippingMessage
            .show()
            .html(productionMessage)
            .addClass('in-production')
            .removeClass('in-stock out-of-stock');
        } else {
          $shippingMessage.hide();
        }
      }
    }
  }
}

/***/ })

}]);